import { useCallback } from "react";
import { queryHref, useSearchParams } from "@/app/navigation";

// Client-only view changes should not refetch a server page or discard an editor draft.
export function useUrlState() {
  const params = useSearchParams();
  const update = useCallback((changes: Record<string, string | null>, replace = false) => {
    const href =
      queryHref(window.location.pathname, new URLSearchParams(window.location.search), changes) +
      window.location.hash;
    if (href === window.location.pathname + window.location.search + window.location.hash) return;
    window.history[replace ? "replaceState" : "pushState"](null, "", href);
  }, []);
  return { params, update };
}
